module.exports = __webpack_public_path__ + "img/defend-card.2eba5f0b.png";